module.exports = __webpack_public_path__ + "static/img/TJ@2x.d95519f9.jpg";